import { useIsomorphicLayoutEffect } from '@react-hookz/web';
import { useSearchParams } from 'next/navigation';

import { getIsForcedNSFWRoute } from '~constants/routes';
import { QUERY_TOKEN_PARAM_NAME } from '~constants/token';
import { NsfwReason } from '~features/annals';
import { loadFromStorage, lsKeys } from '~features/storage';
import { useSession } from '~hooks/useSession';
import { usePathname } from '~i18n/navigation';

import { useSwitchSafeModeWithAgeValidation } from './useSwitchSafeMode';

export const usePresetSafeMode = () => {
	const { isSafeMode, isSuccess } = useSession();
	const searchParams = useSearchParams();
	const pathname = usePathname();

	const updateSafeMode = useSwitchSafeModeWithAgeValidation();

	useIsomorphicLayoutEffect(() => {
		if (isSuccess) {
			const fromLanding =
				searchParams.get('utm_medium') !== 'email' &&
				searchParams.get(QUERY_TOKEN_PARAM_NAME);
			const nsfwPath = getIsForcedNSFWRoute(pathname) || fromLanding;

			const forceSFWSwitch = loadFromStorage(
				lsKeys.FORCE_MODE_SWITCH,
				false,
				true
			);

			if (forceSFWSwitch) {
				window.localStorage.removeItem(lsKeys.FORCE_MODE_SWITCH);
				void updateSafeMode(true, {
					force: true,
					nsfwReason: NsfwReason.Grid,
				});
			} else if (nsfwPath && isSafeMode) {
				void updateSafeMode(false, {
					force: true,
					nsfwReason: NsfwReason.Grid,
				});
			}
		}
	}, [isSuccess]);
};
